<template>
  <div class="card stats-card">
    <div class="card-content">
      <div class="row">
        <div class="col-xs-5">
          <slot name="header"></slot>
        </div>
        <div class="col-xs-7">
          <slot name="content"></slot>
        </div>
      </div>
    </div>
    <div class="card-footer">
      <hr/>
      <slot name="footer"></slot>
    </div>

  </div>
</template>
<script>
  export default {
    name: 'stats-card'
  }

</script>
<style scoped>
  .card.stats-card {
    min-height: 160px
  }
  .card-content{
    min-height: 85px
  }
  .stats-card .card-footer {
    position: absolute;
    bottom: 0;    
    width: 100%;
  }
</style>
